import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations } from 'vuexfire'
import teachers from './teachers'
import classesAP from './classesAP'
import ehtmembers from './ehtmembers'
import mappings from './mappings'
import violations from './violations'
import cases from './cases'
import extra from './extra'
import schools from './schools'
import whistles from './whistles'
import feeling from './feeling'
import user from './user'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  store: {
    responsiveNav: false
  },
  modules: {
    teachers,
    ehtmembers,
    cases,
    classesAP,
    schools,
    whistles,
    feeling,
    extra,
    violations,
    mappings,
    user
  },
  mutations: {
    ...vuexfireMutations
  }
})
